// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-dashboard-app--portalDashboardApp--36H3Dz7b {\n  height: 100%;\n  color: #3f3f3f;\n  font-family: lato, arial, helvetica, sans-serif;\n  overflow: hidden;\n}\n.portal-dashboard-app--portalDashboardApp--36H3Dz7b .portal-dashboard-app--navigation--1SjQ_d-Y {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n.portal-dashboard-app--portalDashboardApp--36H3Dz7b .portal-dashboard-app--progressTable--2TNSBs7G {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  height: calc(100vh - 245px - 60px - 8px);\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n  background-color: white;\n}\n", ""]);
// Exports
exports.locals = {
	"portalDashboardApp": "portal-dashboard-app--portalDashboardApp--36H3Dz7b",
	"navigation": "portal-dashboard-app--navigation--1SjQ_d-Y",
	"progressTable": "portal-dashboard-app--progressTable--2TNSBs7G"
};
module.exports = exports;
